const popularData = [
    {
        name: 'Popular 1',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/tB6Yzc5xIgM.jpg'
    },
    {
        name: 'Popular 2',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/I7bFLTYSxvX.jpg'
    },
    {
        name: 'Popular 3',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/b94mgcfH9dj.jpg'
    },
    {
        name: 'Popular 4',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/8B15m1j6MF8.jpg'
    },
    {
        name: 'Popular 5',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/9u5uSTIj8wl.jpg'
    },
    {
        name: 'Popular 6',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/Omj1h8z4K20.jpg'
    },
    {
        name: 'Popular 7',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/Kd1owAEqWSB.jpg'
    },
    {
        name: 'Popular 8',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/W518A3z1Ne1.jpg'
    },
    {
        name: 'Popular 9',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/2Z2ghRFmDNS.jpg'
    },
    {
        name: 'Popular 10',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/bsvbG9OzO2T.jpg'
    },
    {
        name: 'Popular 11',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/tB6Yzc5xIgM.jpg'
    },
    {
        name: 'Popular 12',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/4763O8V75pf.jpg'
    },
    {
        name: 'Popular 13',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/tB6Yzc5xIgM.jpg'
    },
    {
        name: 'Popular 14',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/tB6Yzc5xIgM.jpg'
    },
    {
        name: 'Popular 15',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/QW1KCCz8RWN.jpg'
    },
    {
        name: 'Popular 16',
        img: 'https://cdn.bioscopelive.com/upload/content/tivoPortrait/hd/tB6Yzc5xIgM.jpg'
    }
]

export default popularData;